export { default } from './ChipClosable';
